import { render } from "./update_password.vue?vue&type=template&id=6363c119"
import script from "./update_password.vue?vue&type=script&lang=js"
export * from "./update_password.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__